<template>

    <span class="icon" :class="colore" :title="descrizioneLocale" v-if="!aggiornamentoIcona && visibile"><i :class="icona"></i></span>

</template>

<script setup>
    import { defineProps, computed, watch, ref, nextTick } from "vue";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        nome: {
            type: String,
            default: null
        },
        descrizione: {
            type: String,
            default: null
        },
        visibileSempre: {
            type: Boolean,
            default: true
        }
    });

    // VARIABILI DEL COMPONENTE
    const aggiornamentoIcona = ref(false);

    const visibile = computed(()=>{
        if (props.visibileSempre) {
            return true;
        } else {
            if (props.descrizione && props.descrizione != '') {
                return true;
            } else {
                return false;
            }
        }
    });

    const descrizioneLocale = computed(()=>{
        for (let i=0; i<aspettoIcone.length; i++) {
            if (aspettoIcone[i].nome == props.nome) {
                if (aspettoIcone[i].descrizione == 'utente') {
                    return props.descrizione;
                } else {
                    return props.nome;
                }
            }
        }
        return null;
    });

    const colore = computed(()=>{
        for (let i=0; i<aspettoIcone.length; i++) {
            if (aspettoIcone[i].nome == props.nome) {
                return aspettoIcone[i].colore;
            }
        }
        return null;
    });

    const icona = computed(()=>{
        for (let i=0; i<aspettoIcone.length; i++) {
            if (aspettoIcone[i].nome == props.nome) {
                return aspettoIcone[i].icona;
            }
        }
        return null;
    });

    const aspettoIcone = [
        {
            nome: 'Urgente',
            colore: 'has-text-danger',
            icona: 'fas fa-exclamation-triangle'
        },
        {
            nome: 'In attesa',
            colore: 'has-text-warning',
            icona: 'fas fa-square'
        },
        {
            nome: 'Archiviato',
            colore: 'has-text-success',
            icona: 'fas fa-check'
        },
        {
            nome: 'Non processato',
            colore: 'has-text-danger',
            icona: 'fas fa-ban'
        },
        {
            nome: 'Non iniziabile',
            colore: 'has-text-danger',
            icona: 'fas fa-ban'
        },
        {
            nome: 'In attesa',
            colore: 'has-text-warning',
            icona: 'fas fa-regular fa-square'
        },
        {
            nome: 'In lavorazione',
            colore: 'has-text-warning',
            icona: 'fas fa-play'
        },
        {
            nome: 'In verifica',
            colore: 'has-text-warning',
            icona: 'fas fa-check'
        },
        {
            nome: 'Eseguito',
            colore: 'has-text-success',
            icona: 'fas fa-check'
        },
        {
            nome: 'Sospeso',
            colore: 'has-text-danger',
            icona: 'fas fa-pause'
        },
        {
            nome: 'Urgente',
            colore: 'has-text-danger',
            icona: 'fas fa-pause'
        },
        {
            nome: 'Nuovo',
            colore: 'has-text-danger',
            icona: 'fas fa-solid fa-bell'
        },
        {
            nome: 'Lavoro',
            colore: '',
            icona: 'fas fa-person-digging'
        },
        {
            nome: 'Documentazione',
            colore: '',
            icona: 'fas fa-book'
        },
        {
            nome: 'Attivo',
            colore: 'has-text-success',
            icona: 'fas fa-check'
        },
        {
            nome: 'Inviato',
            colore: '',
            icona: 'fas fa-check'
        },
        // {
        //     nome: 'CheckFalse',
        //     colore: '',
        //     icona: ''
        // },
        {
            nome: 'Costo',
            colore: '',
            icona: 'fas fa-eur'
        },
        {
            nome: 'Extra',
            colore: 'has-text-danger',
            icona: 'fas fa-check'
        },
        {
            nome: 'Intervento in garanzia',
            colore: 'has-text-danger',
            icona: 'fas fa-check'
        },
        {
            nome: 'Nota',
            colore: '',
            icona: 'fas fa-book',
            descrizione: 'utente'
        },
    ]

    // SETUP DEL COMPONENTE

    // FUNZIONI DEL COMPONENTE
    watch(props, async () => {
        aggiornamentoIcona.value = true;
        await nextTick();
        aggiornamentoIcona.value = false;
    });

</script>